<!-- - ALARM VIDEO (VIDEO EVENT)-->
<div
  class="event-log-box"
  [id]="'log-box-' + log.id"
  [class.is-select]="log.isSelected"
  [class.is-warning]="parseWarningLog()"
  (mouseenter)="onHoverLog($event)"
  (mouseleave)="onMouseLeaveLog($event)"
>
  <div class="event-log-action-box">
    <div class="action-box full-height" [ngClass]="computedBackground()">
      <div class="loader absolute log-loader" *ngIf="log.isLoading">
        <svg class="circular" viewBox="25 25 50 50">
          <circle
            class="path log-stroke-color"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="4"
            stroke-miterlimit="10"
          ></circle>
        </svg>
      </div>
      <ng-container *ngIf="!log.isLoading && !isShowVideo" [ngSwitch]="canIShowImage()">
        <div *ngSwitchCase="'no permission'">No Permission</div>
        <div *ngSwitchCase="'need to upgrade plan'">Upgrade your dealer plan to access archived video.</div>
        <div *ngSwitchCase="'expired'">This video is expired</div>
        <div *ngSwitchCase="'privacy mode'">This camera is in privacy mode</div>
        <div *ngSwitchCase="'broken image'">Broken Image</div>
        <div
          class="v-center"
          *ngSwitchCase="'image'"
          style="position: relative; justify-content: center"
          (click)="toggleToVideo($event)"
          (mouseenter)="mouseOverImage($event)"
          (mouseleave)="mouseLeaveImage($event)"
        >
          <img [src]="log.imageUrl" (load)="imgLoaded()" (error)="imgError($event)" />
          <div class="play-btn" *ngIf="isShowPlayBtn">
            <i class="material-icons" style="color: white; font-size: 32px">play_arrow</i>
          </div>
          <div class="hover-img" *ngIf="isShowPlayBtn">
            <img [src]="log.imageUrl" (load)="imgLoaded()" (error)="imgError($event)" />
          </div>
        </div>
        <div class="v-center" *ngSwitchDefault style="height: 168px">
          <i class="material-icons" style="color: #ff6b6b; font-size: 32px">videocam</i>
        </div>
      </ng-container>
      <ng-container *ngIf="!log.isLoading && isShowVideo" [ngSwitch]="canIShowVideo()">
        <div *ngSwitchCase="'no permission'">No Permission</div>
        <div *ngSwitchCase="'expired'">This video is expired</div>
        <div *ngSwitchCase="'privacy mode'">This camera is in privacy mode</div>
        <div *ngSwitchCase="'broken video'">Broken Video</div>
        <div *ngSwitchCase="'video'" (click)="toggleToVideo($event)">
          <video [src]="log.safetyVideoUrl" controls="controls" autoplay="autoplay" muted="muted"></video>
        </div>
        <div class="v-center" *ngSwitchDefault style="height: 168px">
          <i class="material-icons" style="color: #ff6b6b; font-size: 32px">videocam</i>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="event-log-metadata">
    <div class="flex" style="gap: 6px; flex-direction: column">
      <div class="v-center" style="gap: 8px; flex-wrap: wrap">
        <div class="event-log-metadata-time">{{ log.eventCreated }}</div>
        <div class="event-log-metadata-category" *ngIf="!isAutomationRule()">
          <div class="badge alarm-video">Alarm Video</div>
        </div>
        <div class="badge automation" *ngIf="isAutomationRule()">Automation Action</div>
        <div
          class="--g-tooltip-content"
          *ngIf="parseWarningLog()"
          (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
        >
          <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'rgb(205, 61, 100)'"></comp-icon>
          <div class="--g-tooltip" style="text-transform: none">
            This event includes data that could not be transmitted to the monitoring station.
          </div>
        </div>
      </div>
      <div class="v-center" style="gap: 8px; flex-wrap: wrap">
        <div class="badge video-ai" *ngIf="isVideoAI()">Video AI</div>
        <div class="badge verification" *ngIf="log.isHasVerification">Verification</div>
        <div class="badge entry-event" *ngIf="isShowEntryEventBadge()">Entry Event</div>
        <ng-container *ngFor="let list of log.eventCodeList">
          <div
            class="--g-tooltip-content"
            (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
            style="margin: 0"
          >
            <div class="badge xml-code">{{ list.code }}</div>
            <div class="--g-tooltip tooltip-background">XML Code</div>
          </div>
        </ng-container>
      </div>
      <div class="event-log-metadata-device">
        <div
          class="--g-tooltip-content"
          *ngIf="log.zone_number"
          (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
          style="margin: 0"
        >
          <div class="event-log-metadata-device-zone">{{ log.zone_number }}</div>
          <div class="--g-tooltip tooltip-background">Device ID</div>
        </div>
        <div class="event-log-metadata-device-name" [class.no-name]="!log.name">{{ log.name ?? "No Name" }}</div>
      </div>
      <div class="event-log-metadata-other">
        <div class="flex v-center" *ngIf="isVideoAI()">
          <div>AI Result</div>
          <div style="margin-left: 4px">
            <span style="font-weight: 600">- {{ log.videoAIResult }} </span
            ><span *ngIf="log.videoAIResult === 'True' || log.videoAIResult === 'False'"
              >({{ parseVideoAIResult(log.meta) }})</span
            >
          </div>
        </div>
        <div class="flex v-center" *ngIf="log.email">
          <div class="badge operator-viewed">Viewed</div>
          <div style="margin-left: 8px" *ngIf="!IPuserName">- {{ log.email }}</div>
          <div style="margin-left: 8px" *ngIf="IPuserName">- {{ IPuserName }} ({{ log.ip }})</div>
          <div *ngIf="log?.partnerDescription">{{ log?.partnerDescription }}</div>
        </div>
      </div>
    </div>
    <div class="event-log-metadata-id">
      <span *ngIf="log?.event_id">ID {{ log.event_id }}</span>
      <span *ngIf="log?.partnerEventId"> | Partner ID {{ log.partnerEventId }}</span>
    </div>
    <!-- SLOT : toolbar-->
    <ng-container *ngTemplateOutlet="toolbar; context: { log: log }"></ng-container>
  </div>
</div>
